import { Component, HostBinding, inject, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { RouterOutlet } from '@angular/router';
import packageJson from '../../package.json';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  @HostBinding('attr.app-version')
  readonly appVersion = packageJson.version;

  private readonly _iconRegistry = inject(MatIconRegistry);

  ngOnInit() {
    this._iconRegistry.setDefaultFontSetClass('material-symbols-outlined');
  }
}
